import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "filtersPanel", "filterToggle", "chevron", "searchInput"]
  static values = { debounceDelay: { type: Number, default: 300 } }

  connect() {
    this.debounceTimer = null
    this.clickOutsideHandler = this.clickOutside.bind(this)
  }

  disconnect() {
    this.clearDebounceTimer()
    document.removeEventListener('click', this.clickOutsideHandler)
  }

  toggleFilters(event) {
    event.preventDefault()
    event.stopPropagation()
    
    const isHidden = this.filtersPanelTarget.classList.contains('hidden')
    
    if (isHidden) {
      this.showFilters()
    } else {
      this.hideFilters()
    }
  }

  showFilters() {
    this.filtersPanelTarget.classList.remove('hidden')
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.add('rotate-180')
    }
    
    // Add click outside listener after a brief delay to avoid immediate triggering
    setTimeout(() => {
      document.addEventListener('click', this.clickOutsideHandler)
    }, 100)
  }

  hideFilters() {
    this.filtersPanelTarget.classList.add('hidden')
    if (this.hasChevronTarget) {
      this.chevronTarget.classList.remove('rotate-180')
    }
    document.removeEventListener('click', this.clickOutsideHandler)
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideFilters()
    }
  }

  submit() {
    this.formTarget.requestSubmit()
  }

  debounceSubmit() {
    this.clearDebounceTimer()
    this.debounceTimer = setTimeout(() => {
      // Store the current input focus state
      const activeElement = document.activeElement
      const isSearchInputFocused = activeElement === this.searchInputTarget
      const cursorPosition = isSearchInputFocused ? activeElement.selectionStart : null
      const inputValue = this.searchInputTarget.value
      
      // Listen for turbo:load to restore focus after page replacement
      const restoreFocus = () => {
        const newSearchInput = document.querySelector('[data-admin-filter-target="searchInput"]')
        if (newSearchInput && isSearchInputFocused) {
          newSearchInput.focus()
          newSearchInput.setSelectionRange(cursorPosition, cursorPosition)
        }
        document.removeEventListener('turbo:load', restoreFocus)
      }
      
      if (isSearchInputFocused) {
        document.addEventListener('turbo:load', restoreFocus)
      }
      
      this.submit()
    }, this.debounceDelayValue)
  }

  clearDebounceTimer() {
    if (this.debounceTimer) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = null
    }
  }

  // Handle escape key to close filters
  keydown(event) {
    if (event.key === 'Escape' && !this.filtersPanelTarget.classList.contains('hidden')) {
      this.hideFilters()
    }
  }
}